import drawInfo from "./drawInfo";
import boarspear from "./boarspear";

const drawLuccaBoarInfo = {
  shapes: [...drawInfo.shapes, ...boarspear],
};

export default drawLuccaBoarInfo;
